import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec3489fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "periodontal-graphic" }
const _hoisted_2 = { class: "periodontal-graphic__item" }
const _hoisted_3 = {
  key: 0,
  class: "legend-palatine"
}
const _hoisted_4 = {
  key: 1,
  class: "legend-palatine"
}
const _hoisted_5 = {
  key: 0,
  class: "legend-tongue"
}
const _hoisted_6 = {
  key: 1,
  class: "legend-tongue"
}

import { computed } from 'vue'
import PeriodontalChart from '@/entities/EPeriodontalGraphic/components/PeriodontalChart.vue'
import { PeriodontalDiagramType } from '@/shared/types'
import { useRoute } from 'vue-router'

interface Props {
  isPdfMode?: boolean
  isInteractive?: boolean
  isReverse?: boolean
  isUpperTeeth: boolean
  facialSideData: PeriodontalDiagramType
  facialSidePreviousData: PeriodontalDiagramType
  tongueSideData: PeriodontalDiagramType
  tongueSidePreviousData: PeriodontalDiagramType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isPdfMode: { type: Boolean },
    isInteractive: { type: Boolean },
    isReverse: { type: Boolean },
    isUpperTeeth: { type: Boolean },
    facialSideData: null,
    facialSidePreviousData: null,
    tongueSideData: null,
    tongueSidePreviousData: null
  },
  setup(__props: any) {



const route = useRoute()

const isPreviewMode = computed(() => route.query['view-mode'] === '1')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{
          'periodontal-graphic__legend--interactive': __props.isInteractive,
          'periodontal-graphic__legend--preview': _unref(isPreviewMode) || __props.isPdfMode,
        }, "periodontal-graphic__legend"])
      }, [
        (__props.isReverse)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Лицевая"))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, "Лицевая"))
      ], 2),
      _createVNode(PeriodontalChart, {
        class: _normalizeClass([{
          'periodontal-graphic__chart--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-graphic__chart--interactive': __props.isInteractive,
        }, "periodontal-graphic__chart"]),
        data: __props.facialSideData,
        "previous-data": __props.facialSidePreviousData,
        "is-interactive": __props.isInteractive,
        "is-pdf-mode": __props.isPdfMode,
        "is-upper-teeth": __props.isUpperTeeth
      }, null, 8, ["class", "data", "previous-data", "is-interactive", "is-pdf-mode", "is-upper-teeth"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{
        'periodontal-graphic__item--preview': _unref(isPreviewMode) || __props.isPdfMode,
        'periodontal-graphic__item--interactive': __props.isInteractive,
      }, "periodontal-graphic__item"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{
          'periodontal-graphic__legend--interactive': __props.isInteractive,
          'periodontal-graphic__legend--preview': _unref(isPreviewMode) || __props.isPdfMode,
        }, "periodontal-graphic__legend"])
      }, [
        (__props.isReverse)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Язычная"))
          : (_openBlock(), _createElementBlock("p", _hoisted_6, "Нёбная"))
      ], 2),
      _createVNode(PeriodontalChart, {
        class: _normalizeClass([{
          'periodontal-graphic__chart--preview': _unref(isPreviewMode) || __props.isPdfMode,
          'periodontal-graphic__chart-down': __props.isInteractive,
        }, "periodontal-graphic__chart"]),
        data: __props.tongueSideData,
        "previous-data": __props.tongueSidePreviousData,
        "is-interactive": __props.isInteractive,
        "is-pdf-mode": __props.isPdfMode,
        "is-upper-teeth": __props.isUpperTeeth,
        "is-reverse": ""
      }, null, 8, ["class", "data", "previous-data", "is-interactive", "is-pdf-mode", "is-upper-teeth"])
    ], 2)
  ]))
}
}

})